import client from "./client";

export const liveMap = async () => (await client.get("/live-map")).data;
